module.exports = __webpack_public_path__ + "c1a818ded8569cd0f6207ad18ef47e4e.png";